module.exports = __webpack_public_path__ + "static/sport/img.9e36dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/img.png
// module id = 93Sk
// module chunks = 0